import { useTranslation } from 'react-i18next'

import { Chip, Text } from '@reveni-io/reveni-ui'

import VerticalDivider from '@/common/components/VerticalDivider/VerticalDivider'
import { integrationsCategories } from '@/configuration/pages/ConfigurationPage/IntegrationsConfigurations/constants'

import * as Styles from './styles'

const IntegrationInfo = ({ integration }) => {
  const { t } = useTranslation()

  const getCategoryLabel = () => {
    const category = integrationsCategories.find(category => category.type === integration?.category)
    return (
      <Styles.CategoryLabelContainer>
        {category?.icon} {t(category?.name)}
      </Styles.CategoryLabelContainer>
    )
  }

  return (
    <Styles.Container>
      <Styles.Logo src={integration?.logo_url || '/images/placeholderImg.png'} alt={integration?.name} />
      <VerticalDivider />
      <Styles.InfoContainer>
        <Text type="bodyMBold">{integration?.name}</Text>
        <Chip label={getCategoryLabel()} />
      </Styles.InfoContainer>
    </Styles.Container>
  )
}
export default IntegrationInfo
